(function(Drupal, $, once){
    Drupal.behaviors.htb = {
        attach() {
            $(once('htb', 'body')).first().each(function(){
                var closeClass = '--closed';
                var filtersCloseClass = '--filters-closed';
                var $htb = $('.htb');
                var $drawer = $htb.find('.htb__drawer');
                var $results = $drawer.find('.htb__drawer__results');
                var $resultsCards = $results.find('.MO34');
                var $resultsCardsTitles =  $resultsCards.find('.MO34__header__title');
                var $toggle = $drawer.find('.htb__drawer__toggle, .htb__drawer__filters__search__toggle');
                var $filtersToggle = $drawer.find('.htb__drawer__filters-toggle');
                var mapId = 'leaflet-map-view-how-to-buy-how-to-buy-page';
                var $layers = $('.leaflet-control-layers-toggle');
                var tabletViewport = 834;

                // Close drawer and filters by default on mobile.
                if ($(window).width() <= tabletViewport) {
                    $drawer.addClass(closeClass);
                }
                $drawer.addClass(filtersCloseClass);

                // Expand/collapse results cards.
                $resultsCards.click(function(){
                    if (!$(this).mo34IsSelected()) {
                        $resultsCards.mo34Collapse().mo34Unselect();
                        $(this).mo34Select();
                    }
                });

                // Handle accessibility tab.
                $resultsCardsTitles.focus( function() {
                    if ($('body').hasClass('using-keyboard')) {
                        $(this).closest('.MO34').trigger("click");
                    }
                });

                $(document).on('focusin', function(event) {
                    const $focused = $(event.target);
                    if ($focused && (!$focused.hasClass('leaflet-control-layers-selector') && !$focused.hasClass('leaflet-control-layers-toggle'))) {
                        $layers.parent().removeClass('leaflet-control-layers-expanded');
                    }
                } );

                // Open/close drawer.
                $toggle.click(function(){
                    $drawer.toggleClass(closeClass);
                });

                // Open/close filters on mobile.
                $filtersToggle.click(function(){
                    $drawer.toggleClass(filtersCloseClass);
                });

                // Add class when the map displays no results.
                if (!$drawer.find('.htb__drawer__results__list').length) {
                    $htb.addClass('htb--no-results');
                }

                // Bind listing results to map popups and set map drag/scroll limit.
                if (typeof Drupal.Leaflet !== 'undefined' && Drupal.Leaflet[mapId]) {
                    var leafletMap = Drupal.Leaflet[mapId];
                    var map = leafletMap.lMap;
                    var markers = leafletMap.markers;

                    // Limit drag/scroll.
                    map.setMaxBounds([[-90, -300],[90, 300]]);

                    var iconSelected = new (L.Icon.extend({
                        options: {
                            iconUrl: '/themes/custom/ukho_admiralty/assets/images/htb-selected-marker.svg',
                            iconSize: [60,60]
                        }
                    }));

                    var iconUnselected = new (L.Icon.extend({
                        options: {
                            iconUrl: '/themes/custom/ukho_admiralty/assets/images/htb-unselected-marker.svg',
                            iconSize: [60,60]
                        }
                    }));

                    // Change map fit mode on mobile.
                    const maxDeviceWidth = 600;

                    $(window).resize(function() {
                        const viewportWidth = $(window).width();

                        if (viewportWidth <= maxDeviceWidth) {
                            map.fitBounds([
                                [48.953, -8.160],
                                [50.952, 18.131],
                            ]);
                        }
                    });

                    // Change marker icon to show as selected.
                    function selectMarkerIcon(selectedKey) {
                        for (const key in markers) {
                            markers[key].setIcon(iconUnselected);
                        }
                        markers[selectedKey].setIcon(iconSelected);
                    }

                    // Open relevant marker popup on selection in results listing.
                    $resultsCards.each(function(){
                        $(this).click(function(){
                            var markerId = $(this).parent().data('marker-id');
                            // Amend the markerId as when there is only one results the marker doesn't have
                            // -0 or -1 on the end!
                            if ($resultsCards.length == 1) {
                                // Strip the -0 or -1 from markerId string
                                markerId = markerId.substring(0, markerId.length - 2);
                            }

                            if (markers[markerId]) {
                                setTimeout(function () {
                                    map.setView(markers[markerId].getLatLng(), '20');
                                    markers[markerId].fire('click');
                                    selectMarkerIcon(markerId);
                                }, 500);
                            }
                        });
                    });

                    // Select relevant listing result when clicking on a map marker.
                    for (const key in markers) {
                        var $linkedResult;
                        markers[key].setIcon(iconUnselected);
                        markers[key].on('click', function(){
                            // If there is 1 result, grab the first
                            if ($resultsCards.length == 1) {
                                $linkedResult = $results.first();
                            } else {
                                $linkedResult = $results.find('[data-marker-id="' + key + '"] .MO34');
                            }
                            $linkedResult.get(0).scrollIntoView();
                            if (!$linkedResult.mo34IsSelected()) {
                                $resultsCards.mo34Collapse().mo34Unselect();
                                $linkedResult.mo34Select();
                                selectMarkerIcon(key);
                            }

                            // Open drawer and results panel on mobile.
                            if ($(window).width() <= tabletViewport) {
                                $drawer.removeClass(closeClass);
                                $drawer.addClass(filtersCloseClass);
                            }

                            // Set alt attribute to popup close button and remove link content.
                            var popupCloseButton = $('.leaflet-popup-close-button');
                            popupCloseButton.attr('title', 'Close').empty();
                        });
                    }
                }

                // Tags management.
                var $tagsContainer = $drawer.find('.htb__drawer__tags');
                var $tagFilters = $drawer.find('.htb__drawer__filters__tags input[type="checkbox"]');
                var $checked = $tagFilters.filter(':checked');

                $checked.each(function(){
                    var $input = $(this);
                    var label = $input.siblings('label').first().text();
                    var tagClasses = 'tag tag--clickable icon--close-regular icon-after';

                    var $tag = $('<span></span>').text(label).addClass(tagClasses).attr('tabindex', '0').click(function(){
                        removeTag($input);
                    });

                    $tag.on('keyup', function() {
                        const enterKeyCode = 13;
                        if (event.keyCode === enterKeyCode) {
                            removeTag($input);
                        }
                    });

                    function removeTag(elem) {
                        elem.prop('checked', false);
                        elem.closest('form').submit();
                    }

                    $tagsContainer.append($tag);
                });

                if ($checked.length > 0) {
                    var $filtersCount = $drawer.find('.htb__drawer__filters-toggle__count');
                    $filtersCount.text('(' + $checked.length + ')');
                }

                // Clear tags.
                $drawer.find('.htb__drawer__filters__tags button.reset').click(function(){
                    $tagFilters.prop('checked', false);
                    $(this).closest('form').submit();
                });

                // Custom dropdowns.
                $('.ukho-dropdown').each(function(){
                    var $dropdown = $(this);
                    var $dropdownContent = $dropdown.find('.ukho-dropdown__content');
                    var $dropdownButton = $dropdown.find('.ukho-dropdown__toggle');


                    $dropdown.find('.ukho-dropdown__toggle').click(function(){

                        $dropdown.toggleClass('--opened');

                        // Manage accessibility arias.
                        var ariaExpanded = $dropdownButton.attr('aria-expanded') === 'true';
                        var ariaHidden = $dropdownContent.attr('aria-hidden') === 'true';
                        $dropdownButton.attr('aria-expanded', !ariaExpanded );
                        $dropdownContent.attr('aria-hidden', !ariaHidden);

                    });
                });
            });
        }
    };
})(Drupal, jQuery, once);
